var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"c-nav--main"},[_vm._v("\n  TEST\n  "),_c('ul',_vm._l((_vm.getItemsByLevel),function(item){return _c('li',{key:item.id},[_c('Button',{attrs:{"nupsi":""}},[_vm._v(_vm._s(item.name))])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }